import React from "react";
import { connect } from "react-redux";
import { get, filter } from "lodash";

import { fetchGet } from "../../api/fetch";

import Box from "@material-ui/core/Box";

import ProfileSurveyDialog from "./ProfileSurvey/ProfileSurveyDialog";
import AddIcon from "../Common/AddIcon";
import Button from '@material-ui/core/Button';
import { isAllowed } from "../../utils/users";
import { I18n } from "@aws-amplify/core";
import images from "../../assets/img/images";
import { withStyles } from "@material-ui/styles";

const styles = theme => ({
  btn: {
    background: "none",
    '&:hover': {
       background: "#f2f9fa",
    },
  },
})

const AddVerification = (props) => {
  const {
    permissions,
    profile,
    language,
    isMe,
    companies,
    sites,
    zones,
    original=true
  } = props;

  const [openForm, setOpenForm] = React.useState(false);
  const [verifications, setVerifications] = React.useState();
  const [selectedVerification, setSelectedVerification] = React.useState();

  React.useEffect(() => {
    fetchVerifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies, sites, zones]);

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }
  


  const fetchVerifications = async () => {
    try {
      let url = `verifications?devices=00000000-0000-0000-0000-000000000000`;
      if (get(profile, ["type", "id"]))
        url += `&profile_types=${get(profile, ["type", "id"])}`;
      if (companies) url += `&companies=${companies.join(",")}`;
      if (sites) url += `&sites=${sites.join(",")}`;
      if (zones) url += `&zones=${zones.join(",")}`;
      let res = await fetchGet(url);
      setVerifications(filter(res, (v) => v.active));
    } catch (e) {
      console.log(e);
    }
  };
  if (original){
    return (
      <>
        {openForm && (
          <ProfileSurveyDialog
            title={get(selectedVerification, [`description_${language}`])}
            surveys={{}}
            profileId={get(profile, ["id"])}
            profileName={
              get(profile, ["name"]) ||
              `${get(profile, ["firstname"])} ${get(profile, ["lastname"])}`
            }
            language={language}
            hide={{ new: true, leftCol: true }}
            onlyEdit={{
              open: openForm,
              onClose: () => setOpenForm(false),
              selectedVerification: selectedVerification,
              forceEdition: true,
              refreshHistory: () => props.refreshHistory(),
              onSubmit: props.onSubmit,
              noVerificationSubmit: props.noVerificationSubmit,
              noConfirmation: props.noConfirmation,
            }}
          />
        )}
        <Box style={props.style}>
          <AddIcon
            subMenu={verifications}
            labelField={`description_${language}`}
            handleSubMenuSelect={(v) => {
              setOpenForm(true);
              console.log(v)
              setSelectedVerification(v);
            }}
            disabled={isMe && !isAllowed(permissions, "me.verification.create")}
          />
        </Box>
  
      </>
    );
  } else {
    return (
      <>
        {openForm && (
          <ProfileSurveyDialog
            title={get(selectedVerification, [`description_${language}`])}
            surveys={{}}
            profileId={get(profile, ["id"])}
            profileName={
              get(profile, ["name"]) ||
              `${get(profile, ["firstname"])} ${get(profile, ["lastname"])}`
            }
            language={language}
            hide={{ new: true, leftCol: true }}
            onlyEdit={{
              open: openForm,
              onClose: () => setOpenForm(false),
              selectedVerification: selectedVerification,
              forceEdition: true,
              refreshHistory: () => props.refreshHistory(),
              onSubmit: props.onSubmit,
              noVerificationSubmit: props.noVerificationSubmit,
              noConfirmation: props.noConfirmation,
            }}
          />
        )}
        <div style={getWidth() < 355 ? {position: "relative", top: "10px", paddingRight: "5px"} : {position: "relative", top: "10px", paddingRight: "60px"}}>
        <Box style={props.style}>
          <Button className={props.classes.btn} style={getWidth() < 478 ? {position: "relative", top:"-10px", left: "-2px", paddingBottom: "15px"} : {position: "relative", top:"-10px"}} onClick={()=>{setOpenForm(true); setSelectedVerification({version:2, id:6});}}><img src={images.plusIconColored} alt="plus"></img>&nbsp;&nbsp;<span style={{fontWeight: "bold", color: "#0096a7", position: "relative"}}>{I18n.get("createquestion")}</span></Button>
        </Box>
        </div>
  
      </>
    );
  }

};

const mapStateToProps = (state) => {
  return {
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withStyles(styles)(connect(mapStateToProps)(AddVerification));
